<template>
  <div class="form-check p-0">
    <input :id="id" class="form-check-input" type="checkbox" :name="name" :checked="checked" />
    <label v-if="labelText != ''" :for="id" class="custom-control-label">
      {{ labelText }}
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialCheckbox",
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    labelText: {
      type: String,
      default: "",
    },
    checked: Boolean,
  },
};
</script>
